import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import FileSaver from 'file-saver';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { SdtPositionDto, SdtPositionOptimiserDto } from 'src/app/server-api/models';
import { PdfExportService, SdtPositionControllerService } from 'src/app/server-api/services';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';
import { environment } from 'src/environments/environment';
import { ISdtPositionFormGroup } from './ISdtPositionFormGroup';

@Component({
  selector: 'app-sdt-position',
  templateUrl: './sdt-position.component.html',
  styleUrls: ['./sdt-position.component.css']
})
export class SdtPositionComponent extends DetailComponent {
  sdtPosition: SdtPositionDto;
  step: number = 3;
  bermHeightTargets: number[];
  bermSpacings: number[];
  tunnelDepths: number[];
  sdtOptimizers: SdtPositionOptimiserDto[];
  displayedColumns: string[] = [
    'bermHeightDiff',
    'maxPrecSpecs',
    'calcStatus',
    'lastError',
    'lastModificationDate'
  ];
  headerStyle: string;

  constructor(
    public override translate: TranslateService,
    private sdtPositionService: SdtPositionControllerService,
    public override sidenavService: SideNavService,
    public override router: Router,
    private formBuilder: UntypedFormBuilder,
    private pdfExportService: PdfExportService
  ) {
    super(translate, sidenavService, router);
  }

  override ngOnInit()
  {
    this.profilesAllowEdit = 'ADMIN,ENGINEER';
    this.headerStyle = "background: " + environment.main_color + ";color:white;";
    super.ngOnInit();
  }

  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.sdtPosition = {} as any as SdtPositionDto;

    this.initForm();
    this.columnsVisible.set('id', false);
  }

  setStep(index: number) {
    this.step = index;
  }

  override getItem(request) {
    super.getItem(request);

    this.sdtPositionService.getSdtPosition(request).subscribe((data: SdtPositionDto) => {
      this.sdtPosition = data;
      this.name = data.name;
      this.bermHeightTargets = [];
      this.bermSpacings = [];
      this.tunnelDepths = [];
      this.sdtOptimizers = [];

      if (this.sdtPosition.bermHeightTargets)
      {
        this.sdtPosition.bermHeightTargets.forEach((b) =>
        {
          this.bermHeightTargets.push(Math.round(b * 1000) / 1000);
        });
      }
      if (this.sdtPosition.bermSpacing)
      {
        this.sdtPosition.bermSpacing.forEach((b) =>
        {
          this.bermSpacings.push(Math.round(b * 1000) / 1000);
        });
      }
      if (this.sdtPosition.tunnelDepth)
      {
        this.sdtPosition.tunnelDepth.forEach((b) =>
        {
          this.tunnelDepths.push(Math.round(b * 1000) / 1000);
        });
      }
      if (this.sdtPosition.sdtOptimizers)
      {
        this.sdtOptimizers.push(...this.sdtPosition.sdtOptimizers);
        this.sdtOptimizers.forEach((o) => {
          o.bermHeightDiff = Math.round(o.bermHeightDiff * 1000) / 1000;
          o.maxPrecSpecs = Math.round(o.maxPrecSpecs * 1000) / 1000;
        })
        console.log("this.sdt", this.sdtOptimizers.length, this.sdtPosition.sdtOptimizers.length);
      }


      //to fix to many digits from server sometimes
      this.sdtPosition.actInclination = Math.round(this.sdtPosition.actInclination * 1000) / 1000;
      this.sdtPosition.prevInclination = Math.round(this.sdtPosition.prevInclination * 1000) / 1000;
      this.sdtPosition.planInclination = Math.round(this.sdtPosition.planInclination * 1000) / 1000;
      this.sdtPosition.diffBermHeight = Math.round(this.sdtPosition.diffBermHeight * 1000) / 1000;
      this.sdtPosition.actBermSpacing = Math.round(this.sdtPosition.actBermSpacing * 1000) / 1000;
      this.sdtPosition.planBermSpacing = Math.round(this.sdtPosition.planBermSpacing * 1000) / 1000;

      this.initForm();
      this.detailForm.controls['id'].disable();
    },
    (err: string) => {
      window.alert(err.replace('Object', 'Sdt position'));
    });
  }

  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    this.columnsVisible = new Map([
      ['id', false],
      ['name', true],
      ['chainage', true],
      ['actInclination', true],
      ['planInclination', true],
      ['prevInclination', true],
      ['directionGermany', true],
      ['hightFirstBerm', false],
      ['nrBerms', true],
      ['diffBermHeight', true],
      ['autoCorrection', true],
      ['actBermSpacing', false],
      ['planBermSpacing' , true],
      ['latestError', true],
      ['lock', true]
    ]);

    this.detailForm = this.formBuilder.group({
      id: [''],
      name: [{ value: '', disabled: this.disableByProfile}, Validators.required],
      chainage: [{ value: 0, disabled: this.disableByProfile}, Validators.required],
      actInclination: [{ value: 0, disabled: this.disableByProfile}, Validators.required],
      planInclination: [{ value: 0, disabled: true}],
      prevInclination: [{ value: 0, disabled: true}],
      directionGermany: [{ value: false, disabled: this.disableByProfile}],
      hightFirstBerm: [{ value: 0, disabled: this.disableByProfile}],
      nrBerms: [{ value: 0, disabled: this.disableByProfile}],
      diffBermHeight: [{ value: 0, disabled: this.disableByProfile}],
      autoCorrection: [{ value: false, disabled: this.disableByProfile}],
      actBermSpacing: [{ value: 0, disabled: this.disableByProfile}],
      planBermSpacing: [{ value: 0, disabled: true}],
      latestError: [{ value: '', disabled: true}],
      lock: [{ value: false, disabled: true}],

    }) as ISdtPositionFormGroup;

    //patch value dto to formGroup
    //patch value dto to formGroup
    if (this.copy)
      this.copyItem();
    else
    {
      this.detailForm.patchValue(this.sdtPosition);
    }
  }

  override initForm() {
    super.initForm();
    this.initDialogDelete('sdt-position.dialog_title');

    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu', 'icon_print_sdt','icon_next', 'icon_previous',]).subscribe((translations: string) => {
      this.topMenuIcons = [
        {
          icon: 'print',
          title: translations['icon_print_sdt'],
          routerLink: null,
          clickMethod: 'print',
          hide: false
        },
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
          hide: false
        },
        {
          icon: 'arrow_back',
          title: translations['icon_previous'],
          routerLink: null,
          clickMethod: 'navigatePrevious',
          hide: this.hidePrevious
        },
        {
          icon: 'arrow_forward',
          title: translations['icon_next'],
          routerLink: null,
          clickMethod: 'navigateNext',
          hide: this.hideNext
        },
        {
          icon: 'menu',
          title: translations['icon_menu'],
          routerLink: RouterLinkEnum.SDT_POSITIONS_LIST.toString(),
          clickMethod: 'dummy',
          hide: false
        },
      ];
    });
    this.setForm();
  }

  override saveOk() {
    super.saveOk();

    this.sdtPosition = this.detailForm.value;
    this.sdtPosition.bermHeightTargets = this.bermHeightTargets;
    this.sdtPosition.bermSpacing = this.bermSpacings;
    this.sdtPosition.tunnelDepth = this.tunnelDepths;

    var response =
      this.id !== 'new' && !this.copy
        ? this.sdtPositionService.updateSdtPosition({
            id: this.id,
            body: this.sdtPosition,
          })
        : this.sdtPositionService.createSdtPosition({ body: this.sdtPosition });

    response.subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        if (this.id === 'new' || this.copy)
        {
          this.router.navigateByUrl(RouterLinkEnum.SDT_POSITIONS.toString() + data.id);
        }
        else
        {
          this.refresh();
        }
      },
      (err) => {
        this.sidenavService.setLoading(false);
        console.log('Sdt position not created/updated');
        window.alert('Create/update sdt position not possible');
      }
    );
  }


  override delete() {
    super.delete();
    this.sdtPositionService.deleteSdtPosition({ id: this.id }).subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        this.router.navigateByUrl(RouterLinkEnum.SDT_POSITIONS_LIST.toString());
        console.log('item deleted successfully!');
      },
      (error) => {
        this.sidenavService.setLoading(false);
        console.log(error.error.message);
        window.alert('Delete sdt position not possible');
      }
    );
  }


  override copyItem(): void {
    super.copyItem();

    this.sdtPosition.chainage++;
    this.sdtPosition.id = null;
    //patch value dto to formGroup
    this.detailForm.patchValue(this.sdtPosition);
  }

  //https://www.javachinna.com/angular-spring-boot-crud-app/
  print()
  {
    this.sidenavService.setLoading(true);

    this.pdfExportService.exportSdtPosition({id: this.id}).subscribe(
      (pdf) => {
        this.sidenavService.setLoading(false);


        let fileName = "Gravel_Bed_Assessment_" + this.sdtPosition.name.replaceAll(" ", "_") + "_" + formatDate(new Date(), 'yyyy-MM-dd_hh:mm', 'en')  + ".pdf";
        FileSaver.saveAs(pdf, fileName);
      },
      (error) => {
        this.sidenavService.setLoading(false);
        window.alert(this.translate.instant("sdt-position.print-failed"));
      }
    )
  }
}



